// extracted by mini-css-extract-plugin
module.exports = {"soundscape":"Soundscape_soundscape__2df7z","authors":"Soundscape_authors__nB4bk","description":"Soundscape_description__Z435R","copyright":"Soundscape_copyright__b357B"};